import userRoutes from './users.route';

export default [...userRoutes];
